import "./Controls.css"

import { forwardRef, useRef } from "react"
import { v4 as uuid } from "uuid"
import classNames from "classnames"

import Label from "./Label"

import useCombinedRefs from "web/hooks/behaviour/useCombinedRefs"

const CheckBox = forwardRef((props, ref) => {
  const {
    name,
    label,
    description,
    value,
    onChange,
    inline = false,
    hideLabel = false,
    showValueLabel = true,
    disabled = false,
    reverse = false,
    id = uuid(),
  } = props
  const innerRef = useRef()
  const checkbox = useCombinedRefs(ref, innerRef)

  const checkboxValueUndefined = value === undefined || value === null

  const checkboxValue =
    value === undefined || value === null ? false : value.value

  const canShowLabel = !inline && !hideLabel && label

  return (
    <div>
      {canShowLabel && (
        <Label
          htmlFor={id}
          label={label}
          kind="Yes/No"
          description={description}
        />
      )}
      <div
        className={classNames("flex items-center", {
          "opacity-50": disabled,
        })}
      >
        {inline && !reverse && (
          <label htmlFor={id} className="mx-1.5 my-0">
            {label}
          </label>
        )}
        <input
          id={id}
          ref={checkbox}
          data-testid={`form-input-${name}`}
          className={classNames(
            "size-4 rounded border-gray-300 focus:ring-blue-400/50",
            { "text-blue-600": !disabled, "text-gray-400": disabled }
          )}
          type="checkbox"
          checked={checkboxValue}
          onClick={(e) => {
            e.stopPropagation()
          }}
          onChange={(e) => {
            onChange({
              value: e.target.checked,
              kind: "Boolean",
              format: "Boolean",
            })
          }}
          disabled={disabled}
        />
        {inline && reverse && (
          <label htmlFor={id} className="mx-1.5 my-0">
            {label}
          </label>
        )}
        {showValueLabel && (
          <span className="ml-1.5 inline-flex items-center">
            {checkboxValueUndefined ? "Not Set" : checkboxValue ? "Yes" : "No"}
          </span>
        )}
      </div>
    </div>
  )
})

export default CheckBox
